import { Directive, Input, ContentChild, TemplateRef } from "@angular/core";

// https://stackoverflow.com/questions/52319099/how-can-i-transclude-child-component-template-into-its-parent-in-angular-6

/**
 * Directive for select a column and bind content into table
 *
 * @export
 * @class NgTemplateTableDirective
 */
@Directive({
  selector: "ng-template[app-column]"
})
export class NgTemplateTableDirective {
  @Input() title: string;
  @Input() extraClass:Array<string>=[];
  @ContentChild(TemplateRef, {static: false}) template: TemplateRef<any>;
  constructor() { }

}

// https://stackoverflow.com/questions/52319099/how-can-i-transclude-child-component-template-into-its-parent-in-angular-6

/**
 * Directive for binding a row into a table and outlet data
 *
 * @export
 * @class NgTemplateRowTableDirective
 */
@Directive({
  selector: "ng-template[app-row]"
})
export class NgTemplateRowTableDirective {
  @Input() title: string;
  @Input() extraClass:Array<string>=[];
  @ContentChild(TemplateRef, {static: false}) template: TemplateRef<any>;
  constructor() { }

}

// https://stackoverflow.com/questions/52319099/how-can-i-transclude-child-component-template-into-its-parent-in-angular-6

/**
 * Directive for binding a row into a table and outlet data for responsive content
 *
 * @export
 * @class NgTemplateRowTableDirective
 */
@Directive({
  selector: "ng-template[app-column-responsive]"
})
export class NgTemplateRowTableResponseDirective {
  @Input() title: string;
  @Input() extraClass:Array<string>=[];
  @ContentChild(TemplateRef, {static: false}) template: TemplateRef<any>;
  constructor() { }
}
/**
 * Directive for binding a row group into a table and outlet data for responsive content
 *
 * @export
 * @class NgTemplateRowGroupTableResponseDirective
 */
@Directive({
  selector: "ng-template[app-row-group]"
})
export class NgTemplateRowGroupTableResponseDirective {
  @Input() title: string;
  @Input() extraClass: Array<string> = [];
  @ContentChild(TemplateRef, {static: false}) template: TemplateRef<any>;
  constructor() {}
}
